<template>
  <div class="membership_url_page">
    <v-dialog v-model="urlViewDialog" max-width="550">
      <v-card class="membership_url_page">
        <v-card-title class="pl-5 pt-5"
          >쇼핑몰 멤버십 관련 페이지 URL</v-card-title
        >

        <v-card-text class="pb-2">
          <p class="mb-0">
            - 설정하신 멤버십과 관련하여 쇼핑몰 노출되는 페이지 미리보기가
            가능합니다.
          </p>
          <p class="mb-0">
            - 미리보기의 경우 미리보기 페이지 URL로 연결됩니다.
          </p>
          <p class="mb-0">
            - 쇼핑몰 배너,링크를 연결하실때는 'URL 복사' 버튼을 클릭하여
            사용하세요.
          </p>
        </v-card-text>
        <div>
          <v-card class="col-12 ml-5 mt-3 pb-0 pt-0" max-width="510">
            <v-data-table
              :headers="headers"
              :items="items"
              calculate-widths
              hide-default-footer
              outline
              mobile-breakpoint="0"
            >
              <template v-slot:[`item.title`]="{ item }">
                <p class="mb-0 text-center caption">
                  {{ item.title }}
                </p>
              </template>
              <template v-slot:[`item.url`]="{ item }">
                <v-btn
                  depressed
                  small
                  color="primary"
                  class="caption white--text"
                  aling="right"
                  right
                  style="background-color: rgb(127, 127, 127); border-color: rgb(127, 127, 127);"
                  @click="previewMove(item.url, item.preview_url)"
                  >미리보기</v-btn
                >
              </template>
              <!--
                @click="textCopy(item.bigo, item.url)"

              -->
              <template v-slot:[`item.bigo`]="{ item }">
                <v-btn
                  depressed
                  small
                  color="#8292ff"
                  class="caption white--text"
                  aling="right"
                  right
                  style="background-color: rgb(127, 127, 127); border-color: rgb(127, 127, 127);"
                  v-clipboard:copy="item.url"
                  v-clipboard:success="onCopy"
                  v-clipboard:error="onError"
                  >URL 복사</v-btn
                >
              </template>
              <template slot="no-data">
                <div>내역이 없습니다.</div>
              </template>
            </v-data-table>
          </v-card>
        </div>
        <div class="pb-5 mt-0">
          <v-btn
            color="black"
            hide-details
            depressed
            class="white--text ml-5 mr-5 mt-6"
            @click="urlViewDialog = false"
            width="510"
            >닫기</v-btn
          >
        </div>
      </v-card>
    </v-dialog>
    <input type="hidden" v-model="textInput" />
  </div>
</template>

<script>
import M from "@/libs/mapping.js";
import Vue from "vue";
import VueClipboard from "vue-clipboard2";

VueClipboard.config.autoSetContainer = true; // add this line
Vue.use(VueClipboard);

export default {
  data: () => {
    return {
      M,
      urlViewDialog: false,
      product_no: 0,
      category_no: 0,
      headers: [
        {
          text: "항목",
          align: "center",
          value: "title",
          sortable: false,
          width: 260,
          filterable: false,
        },
        {
          text: "미리보기",
          align: "center",
          value: "url",
          sortable: false,
          width: 100,
          filterable: false,
        },
        {
          text: "복사",
          align: "center",
          value: "bigo",
          sortable: false,
          width: 100,
          filterable: false,
        },
      ],
      items: [],
      preview_status: true,
      category_list: [],
      textInput: "",
    };
  },
  methods: {
    reset: function() {
      this.product_no = 0;
      this.category_no = 0;
      this.preview_status = true;
      this.category_list = [];
      this.items = [];
    },
    show: async function(params) {
      this.reset();

      if (params.product_no) {
        this.product_no = params.product_no;
      }

      if (params.base_category_no && params.base_category_no > 0) {
        this.category_no = params.base_category_no;
      }

      this.setItems();

      await this.getCategories();

      // 멤버십 정보 조회
      let get_membership_result = await this.getMembership(
        params.membership_id
      );

      this.urlViewDialog = get_membership_result;
    },

    // 멤버십 정보 조회
    getMembership: async function(membership_id) {
      try {
        let result = await M.api(M.entry("/get/membership", membership_id));

        if (
          result.display_status == "enabled" &&
          result.selling_status == "enabled"
        ) {
          this.preview_status = false;
        }
        if (result.category_info.length > 0) {
          for (let i = 0; i < result.category_info.length; i++) {
            let setParams = {
              title: `${
                this.category_list[result.category_info[i].category_no]
              } 상품 분류`,
              url: `https://${this.$store.state.mallId}.cafe24.com/product/list.html?cate_no=${result.category_info[i].category_no}`,
              bigo: "",
              preview_url: "",
            };
            let info = this.items.find(
              (service) => service.url === setParams.url
            );
            if (!info) {
              this.items.push(setParams);
            }
          }
        }

        return true;
      } catch (e) {
        if (e.response.data.message == "not found product") {
          alert("카페24 어드민에서 삭제된 상품입니다.");
        } else {
          alert("새로고침(F5)하여 재확인해주세요.");
        }

        return false;
      }
    },
    textCopy: function(bigo, text) {
      bigo = "";
      this.textInput = text;
      this.$copyText(this.textInput).then(
        function(e) {
          alert("Copied");
          console.log(e);
        },
        function(e) {
          alert("Can not copy");
          console.log(e);
        }
      );
    },
    onCopy: function() {
      alert("복사 되었습니다.\n붙여넣기(ctrl+v)로 사용하세요.");
    },
    onError: function(e) {
      console.log(e.text);
    },
    setItems: function() {
      this.items = [];
      let setData = [
        {
          title: "멤버십 상품 분류",
          url: `https://${this.$store.state.mallId}.cafe24.com/product/list.html?cate_no=${this.category_no}`,
          bigo: "",
          preview_url: "",
        },
        {
          title: "멤버십 상품 페이지 (PC)",
          url: `https://${this.$store.state.mallId}.cafe24.com/shoplus/membership/src/membership_detail.html?product_no=${this.product_no}`,
          bigo: "",
          preview_url: `https://${this.$store.state.mallId}.cafe24.com/shoplus/membership/src/membership_detail_preview.html?mall_id=${this.$store.state.mallId}&product_no=${this.product_no}&view=1`,
        },
        {
          title: "멤버십 상품 페이지 (Mobile)",
          url: `http://m.${this.$store.state.mallId}.cafe24.com/shoplus/membership/src/membership_detail.html?product_no=${this.product_no}`,
          bigo: "",
          preview_url: `http://m.${this.$store.state.mallId}.cafe24.com/shoplus/membership/src/membership_detail_preview.html?mall_id=${this.$store.state.mallId}&product_no=${this.product_no}&view=1`,
        },
        {
          title: "멤버십 관리 페이지 (PC)",
          url: `https://${this.$store.state.mallId}.cafe24.com/shoplus/membership/src/membership_manage.html?product_no=${this.product_no}`,
          bigo: "",
          preview_url: `https://${this.$store.state.mallId}.cafe24.com/shoplus/membership/src/membership_manage.html?product_no=${this.product_no}&view=1`,
        },
        {
          title: "멤버십 관리 페이지 (Mobile)",
          url: `http://m.${this.$store.state.mallId}.cafe24.com/shoplus/membership/src/membership_manage.html?product_no=${this.product_no}`,
          bigo: "",
          preview_url: `http://m.${this.$store.state.mallId}.cafe24.com/shoplus/membership/src/membership_manage.html?product_no=${this.product_no}&view=1`,
        },
      ];

      this.items = setData;
    },
    urlMove: function(url, preview_url) {
      if (this.preview_status === false) {
        let win = window.open(url, "_blank");
        win.focus();
      } else {
        if (preview_url) {
          alert("현재 상품 미노출 상태로\n미리보기 페이지로 연결됩니다.");
          let win = window.open(preview_url, "_blank");
          win.focus();
        } else {
          let win = window.open(url, "_blank");
          win.focus();
        }
      }
    },
    getCategories: async function() {
      this.category_list = [];
      try {
        let result = await M.api(M.entry("/get/membership/categories"));
        for (let i = 0; i < result.length; i++) {
          this.category_list[result[i].category_no] = result[i].category_name;
        }
      } catch (e) {
        alert("새로고침(F5)하여 재확인해주세요.");
      }
    },
    previewMove: function(url, preview_url) {
      if (preview_url) {
        let win = window.open(preview_url, "_blank");
        win.focus();
      } else {
        let win = window.open(url, "_blank");
        win.focus();
      }
    },
  },
};
</script>
